/* VAXA cart drawer branding.

   The cart is UpCart, which renders inside an open shadow root on #upCart.
   Theme CSS cannot cross that boundary, so the accent styling and the
   reservation strip are injected into the shadow root directly.

   UpCart exposes stable `upcart-public-*` class names for exactly this.

   Note: the announcement colour can also be set in the UpCart dashboard.
   This file makes it correct without needing the app, and is written so the
   app setting wins nothing and loses nothing if it is changed later. */
(function () {
  if (window.__vxCart) return;
  window.__vxCart = true;

  /* Both strips were orange once — delivery / guarantee in #722F37 with the
     reservation strip above it in the darker #5A252C. Two shades of the same
     colour touching read as a mistake, so both went cream on 2026-08-08.
     Cream on cream turned out flat, so as of 2026-08-10 the reservation strip
     takes the brand orange and the delivery / guarantee row stays cream. One
     orange band, not two, and it's the exact #722F37 of the Checkout button —
     so the drawer opens and closes on the same colour. */
  var ORANGE    = '#722F37';        /* reservation strip; matches Secure checkout */
  /* This file is a plain .js asset, so there is no Liquid here. Shopify
     stamps <html lang> per locale, so read the language off that. */
  var VX_IS       = (document.documentElement.lang || '').toLowerCase().indexOf('is') === 0;
  var VX_RESERVED_LABEL = VX_IS ? 'Karfan þín er frátekin í' : 'Your cart is reserved for';
  var CREAM     = '#F9FAFB';        /* delivery / guarantee row */
  var INK       = '#121212';
  var WHITE     = '#FFFFFF';
  var HAIRLINE  = 'rgba(18,18,18,.10)';
  var HOLD_MINUTES = 10;
  var KEY = 'vxCartDeadline';

  var SHADOW_CSS =
    /* Solomon's note: the delivery / guarantee row must stay its own band. It
       still is, just in cream instead of carrying the brand colour itself. */
    '.upcart-public-announcement{background:' + CREAM + ' !important;' +
    'padding:9px 8px !important;' +
    'border-bottom:1px solid ' + HAIRLINE + ' !important;}' +
    '.upcart-public-announcement,.upcart-public-announcement *{color:' + INK + ' !important;' +
    'font-weight:600 !important;}' +
    '.upcart-public-announcement svg,.upcart-public-announcement svg *{fill:currentColor !important;}' +
    /* The row read as two lines on a 375px phone, which made a trust strip look
       like a paragraph. It is one line now. The copy is Mohamed's and does not
       get shortened, so the type shrinks to fit instead — but only as far as it
       has to. cqw measures the drawer, not the window, because the drawer is a
       ~400px panel on desktop while vw would report 1280 and overflow it. The
       11.5px flat fallback fits a 375px phone unaided for anything that has no
       container queries. */
    '.upcart-public-announcement p{white-space:nowrap !important;' +
    'font-size:11.5px !important;margin:0 !important;}' +
    '@supports (container-type:inline-size){' +
    '.upcart-public-announcement{container-type:inline-size;}' +
    '.upcart-public-announcement p{font-size:min(15px,3.2cqw) !important;}}' +
    /* Reservation strip sits above it in the brand orange, so the drawer is
       bookended by the same colour as the Checkout button. White text, and the
       clock inherits it via currentColor. */
    '.vx-cart__bar{display:flex;align-items:center;justify-content:center;gap:7px;' +
    'background:' + ORANGE + ';color:' + WHITE + ';font-size:13px;font-weight:600;' +
    'letter-spacing:.02em;padding:9px 16px;text-align:center;line-height:1.3;}' +
    '.vx-cart__bar svg{flex:none;}' +
    '.vx-cart__time{font-variant-numeric:tabular-nums;font-weight:700;}';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function deadline() {
    var stored = parseInt(sessionStorage.getItem(KEY) || '', 10);
    var now = Date.now();
    if (!stored || stored <= now) {
      stored = now + HOLD_MINUTES * 60 * 1000;
      try { sessionStorage.setItem(KEY, String(stored)); } catch (e) {}
    }
    return stored;
  }

  function shadow() {
    var host = document.getElementById('upCart');
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  function tick() {
    var sr = shadow();
    if (!sr) return;
    var el = sr.querySelector('.vx-cart__time');
    if (!el) return;
    var left = Math.max(0, deadline() - Date.now());
    el.textContent = pad(Math.floor(left / 60000)) + ':' + pad(Math.floor((left % 60000) / 1000));
    if (left === 0) {
      var bar = sr.querySelector('.vx-cart__bar');
      if (bar) bar.textContent = 'Your cart is saved. Check out whenever you are ready.';
    }
  }

  function decorate() {
    var sr = shadow();
    if (!sr) return;

    if (!sr.getElementById || !sr.querySelector('#vx-upcart-css')) {
      var st = document.createElement('style');
      st.id = 'vx-upcart-css';
      st.textContent = SHADOW_CSS;
      sr.appendChild(st);
    }

    var header = sr.querySelector('.upcart-public-header');
    if (header && !sr.querySelector('.vx-cart__bar')) {
      var bar = document.createElement('div');
      bar.className = 'vx-cart__bar';
      bar.innerHTML =
        "<svg viewBox='0 0 24 24' width='15' height='15' aria-hidden='true'>" +
        /* currentColor, not a hard-coded white, so the clock follows whatever the
           strip's text colour is. It was invisible on cream as a white stroke. */
        "<circle cx='12' cy='12' r='9' fill='none' stroke='currentColor' stroke-width='1.9'/>" +
        "<path d='M12 7v5.2l3.4 2' fill='none' stroke='currentColor' stroke-width='1.9' stroke-linecap='round'/></svg>" +
        "<span>" + VX_RESERVED_LABEL +
        " <span class='vx-cart__time'>10:00</span></span>";
      header.insertAdjacentElement('afterend', bar);
      tick();
    }
  }

  function watch() {
    var host = document.getElementById('upCart');
    if (!host || !host.shadowRoot || host.__vxWatched) return;
    host.__vxWatched = true;
    if (window.MutationObserver) {
      new MutationObserver(function () { decorate(); })
        .observe(host.shadowRoot, { childList: true, subtree: true });
    }
  }

  function boot() {
    /* UpCart mounts asynchronously, so poll briefly until the shadow root exists. */
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      decorate();
      watch();
      if (shadow() || tries > 60) clearInterval(iv);
    }, 500);

    setInterval(function () { decorate(); tick(); }, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
